import React from 'react';
import { instanceOf } from 'prop-types';

import './style.scss';

function Wrapper({ children }) {
  return (
    <div className="connections-wrapper">
      <div className="connections-content arc-d-flex">{children}</div>
    </div>
  );
}

Wrapper.propTypes = {
  children: instanceOf(Object).isRequired,
};

export default Wrapper;
